__turbopack_context__.v({
  "affix": "oQM7cG_affix",
  "colorScheme--highlight": "oQM7cG_colorScheme--highlight",
  "colorScheme--negative": "oQM7cG_colorScheme--negative",
  "colorScheme--positive": "oQM7cG_colorScheme--positive",
  "container": "oQM7cG_container",
  "figure": "oQM7cG_figure",
  "icon": "oQM7cG_icon",
  "size--lg": "oQM7cG_size--lg",
  "size--sm": "oQM7cG_size--sm",
  "value": "oQM7cG_value",
});
